module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/4-off-a2c8cb06106a60a26345ff5f286af359.png";